interface SlideImageProps {
  src: string
}

export const SlideImage = ({ src }: SlideImageProps) => {
  const slideStyles = 'h-[60px] border-x-4 border-transparent mx-auto'

  return (
    <div className='w-full'>
      <img src={src} className={slideStyles} alt='' />
    </div>
  )
}
